export default "__VITE_ASSET__BbbZ00NN__"